import { useMutation } from '@apollo/client'
import { UPDATE_USER_PREFERENCES } from './mutations'
import { UpdateUserPreferencesVariables } from './types'

export const useUpdateUserPreferences = () =>
  useMutation<any, UpdateUserPreferencesVariables>(UPDATE_USER_PREFERENCES)
